import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Toast } from 'react-bootstrap';
import useToast from '../login/hook/useToast';
import { Trash2 } from 'lucide-react';
import AddressForm from '../profileInfo/Forms/address/list/AddressForm';
import axios from 'axios';
import { conf } from '../../confg';

const AddressList = ({ addresses, selectedAddressId, onAddressSelect, show, onHide, onAddNewAddress, setIsEditModalOpen, setAddressDetails }) => {
  const { toasts, showSuccessToast, showErrorToast, hideSuccessToast, hideErrorToast } = useToast();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const class_toast = 'bg-success';

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleAddressClick = (addressId) => {
    showSuccessToast('به عنوان آدرس سفارش انتخاب شد ');
    onAddressSelect(addressId);
    onHide();
  };

  const formatAddress = (address) => {
    const parts = [];

    if (address.entry_state) parts.push(address.entry_state);
    if (address.entry_city) parts.push(address.entry_city);
    if (address.entry_street_address) parts.push(address.entry_street_address);
    if (address.pelak) parts.push(`پلاک ${address.pelak}`);
    if (address.vahed) parts.push(`واحد ${address.vahed}`);

    return parts.join('، ');
  };

  const AddressItem = ({ address, isSelected }) => (
    <div className={`address-item ${isSelected ? 'selected' : ''}`} onClick={() => handleAddressClick(address.address_book_id)}>
      <div className='address-header'>
        <div className='address-icon'>
          <i className='fas fa-map-marker-alt'></i>
        </div>
        <div className='address-content'>
          <div className='address-title'>{address.label || 'آدرس'}</div>
          <div className='address-details'>
            <div className='receiver-name'>{`${address.entry_firstname} ${address.entry_lastname}`}</div>
            <div className='address-text'>{formatAddress(address)}</div>
            {address.entry_postcode && <div className='postal-code'>کد پستی: {address.entry_postcode}</div>}
          </div>
        </div>
        <div className='address-actions'>
          <button
            className='edit-btn'
            onClick={(e) => {
              e.stopPropagation();
              setAddressDetails(address);
              setIsEditModalOpen(true);
              onHide();
              onAddNewAddress();
            }}
          >
            <i className='fas fa-edit'></i>
          </button>

          {isSelected && (
            <div className='selected-indicator'>
              <i className='fas fa-check-circle'></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // Mobile Bottom Sheet
  if (isMobile) {
    return (
      <>
        {show && <div className='bottom-sheet-overlay' onClick={onHide} />}
        <div className={`bottom-sheet ${show ? 'show' : ''}`}>
          <div className='bottom-sheet-handle' />
          <div className='bottom-sheet-header'>
            <h5>آدرس های شما</h5>
            <button className='close-btn' onClick={onHide}>
              <i className='fas fa-times'></i>
            </button>
          </div>

          <div className='bottom-sheet-content'>
            <div className='addresses-list'>
              {addresses.map((address) => (
                <AddressItem key={address.address_book_id} address={address} isSelected={address.address_book_id === selectedAddressId} />
              ))}
            </div>

            <div className='add-address-section' style={{ paddingBottom: '70px' }}>
              <button
                className='add-address-btn'
                onClick={() => {
                  onHide();
                  onAddNewAddress();
                }}
              >
                <i className='fas fa-plus'></i>
                افزودن آدرس جدید
              </button>
            </div>
          </div>
        </div>

        <style jsx>{`
          .bottom-sheet-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 1040;
          }

          .bottom-sheet {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            max-height: 100vh;
            transform: translateY(100%);
            transition: transform 0.3s ease-in-out;
            z-index: 1050;
            direction: rtl;
            overflow: scroll;
          }

          .bottom-sheet.show {
            transform: translateY(0);
          }

          .bottom-sheet-handle {
            width: 40px;
            height: 4px;
            background: #ccc;
            border-radius: 2px;
            margin: 10px auto;
          }

          .bottom-sheet-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 20px;
            border-bottom: 1px solid #eee;
            width: 100%;
          }

          .bottom-sheet-header h5 {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
          }

          .close-btn {
            background: none;
            border: none;
            font-size: 20px;
            color: #666;
            padding: 5px;
          }

          .bottom-sheet-content {
            padding: 20px;
            // max-height: calc(80vh - 80px);
            overflow-y: auto;
          }

          .addresses-list {
            margin-bottom: 20px;
          }

          .address-item {
            // background: #f8f9fa;
            border: 2px solid transparent;
            border-radius: 12px;
            padding: 15px;
            margin-bottom: 12px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: 2px solid #e9ecef;
          }

          .address-item:hover {
            // background: #e9ecef;
          }

          .address-item.selected {
            border-color: #01494b;
            // background: rgba(0, 123, 255, 0.1);
          }

          .address-header {
            display: flex;
            gap: 12px;
          }

          .address-icon {
            color: #01494b;
            font-size: 20px;
            margin-top: 2px;
          }

          .address-content {
            flex: 1;
          }

          .address-title {
            font-weight: 600;
            font-size: 16px;
            color: #333;
            margin-bottom: 8px;
          }

          .receiver-name {
            font-size: 14px;
            color: #666;
            margin-bottom: 6px;
          }

          .address-text {
            font-size: 13px;
            color: #555;
            line-height: 1.4;
            margin-bottom: 6px;
          }

          .postal-code {
            font-size: 12px;
            color: #888;
          }

          .address-actions {
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-items: center;
            justify-content: start;
          }

          .edit-btn {
            background: none;
            border: none;
            color: #666;
            font-size: 16px;
            padding: 8px;
            border-radius: 50%;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .edit-btn:hover {
            background: rgba(0, 0, 0, 0.1);
          }

          .selected-indicator {
            color: #01494b;
            font-size: 20px;
          }

          .add-address-section {
            border-top: 1px solid #eee;
            padding-top: 20px;
            margin-bottom: 50px !important;
          }

          .add-address-btn {
            width: 100%;
            background: #01494b;
            color: white;
            border: none;
            border-radius: 12px;
            padding: 15px;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          }

          .add-address-btn:hover {
            // background: #0056b3;
          }
        `}</style>
        <Toast
          className={'rtl position-fixed color-white z-index-top ' + class_toast}
          style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 999999999999,
            borderRadius: '12px',
            border: 'none',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: '350px',
            backgroundColor: '#28a745',
            cursor: 'pointer',
          }}
          show={toasts.success.show}
          onClose={hideSuccessToast}
          onClick={hideSuccessToast}
          autohide={true}
          delay={4000}
        >
          <Toast.Body
            style={{
              padding: '12px 20px',
              fontSize: '12px',
              textAlign: 'center',
              color: 'white',
              fontWeight: '500',
            }}
          >
            {toasts.success.message}
          </Toast.Body>
        </Toast>
      </>
    );
  }

  // Desktop Modal
  return (
    <>
      <Modal show={show} onHide={onHide} size='lg' centered className='address-modal'>
        <Modal.Header
          closeButton
          className='rtl'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem 1.5rem',
            borderBottom: '1px solid #dee2e6',
            width: '100%',
          }}
        >
          <Modal.Title
            style={{
              margin: 0,
              fontSize: '1.25rem',
              fontWeight: 600,
              flex: 1,
              paddingRight: '1rem',
            }}
          >
            آدرس های شما
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='rtl'>
          <div className='desktop-addresses-grid'>
            {addresses.map((address) => (
              <AddressItem key={address.address_book_id} address={address} isSelected={address.address_book_id === selectedAddressId} />
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer className='rtl'>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              style={{ textAlign: 'right', cursor: 'pointer', minWidth: '250px' }}
              onClick={() => {
                onHide();
                onAddNewAddress();
              }}
            >
              <i className='fas fa-plus me-2'></i>
              افزودن آدرس جدید
            </Button>
          </div>
        </Modal.Footer>

        <style jsx>{`
          .desktop-addresses-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
            gap: 15px;
            max-height: 500px;
            overflow-y: auto;
            padding: 10px;
          }

          .address-item {
            // background: #f8f9fa;
            border: 2px solid #01494b;
            border-radius: 12px;
            padding: 20px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: 2px solid #e9ecef;
          }

          .address-item:hover {
            // background: #e9ecef;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          .address-item.selected {
            border-color: #01494b;
            // background: rgba(0, 123, 255, 0.1);
          }

          .address-header {
            display: flex;
            gap: 15px;
          }

          .address-icon {
            color: #01494b;
            font-size: 24px;
            margin-top: 2px;
          }

          .address-content {
            flex: 1;
          }

          .address-title {
            font-weight: 600;
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
          }

          .receiver-name {
            font-size: 16px;
            color: #666;
            margin-bottom: 8px;
          }

          .address-text {
            font-size: 14px;
            color: #555;
            line-height: 1.5;
            margin-bottom: 8px;
          }

          .postal-code {
            font-size: 13px;
            color: #888;
          }

          .address-actions {
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
          }

          .edit-btn {
            background: none;
            border: none;
            color: #666;
            font-size: 18px;
            padding: 10px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .edit-btn:hover {
            background: rgba(0, 0, 0, 0.1);
          }

          .selected-indicator {
            color: #01494b;
            font-size: 24px;
          }
        `}</style>
      </Modal>

      <Toast
        className={'rtl position-fixed color-white z-index-top ' + class_toast}
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 999999999999,
          borderRadius: '12px',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '350px',
          backgroundColor: '#28a745',
          cursor: 'pointer',
        }}
        show={toasts.success.show}
        onClose={hideSuccessToast}
        onClick={hideSuccessToast}
        autohide={true}
        delay={4000}
      >
        <Toast.Body
          style={{
            padding: '12px 20px',
            fontSize: '12px',
            textAlign: 'center',
            color: 'white',
            fontWeight: '500',
          }}
        >
          {toasts.success.message}
        </Toast.Body>
      </Toast>
    </>
  );
};

AddressList.defaultProps = {
  addresses: [],
  selectedAddressId: null,
  onAddressSelect: () => {},
  show: false,
  onHide: () => {},
  onAddNewAddress: () => {},
};

export default AddressList;
